import React from 'react';
import { YInput } from '../../../ui/YInput';
import '../styles/auth-design.css';

export function AuthInputWithIcon({
  id,
  type = 'text',
  icon: Icon,
  value,
  onChange,
  placeholder,
  disabled = false,
  invalid = false,
}) {
  return (
    <div className="auth-input-icon-wrap">
      <span className="auth-input-icon-wrap__icon">
        <Icon size={16} />
      </span>
      <YInput
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        invalid={invalid}
      />
    </div>
  );
}
